import { getAllSystemUrl, newSystemUrl } from "./constants";
import base from "../middlewares/interceptors";

/**
 * Get all systems
 * @returns Promise with systems data
 */
export const getSystemsAll = async () => {
  try {
    const response = await base.get(`${newSystemUrl}/all`);
    return response.data;
  } catch (error) {
    console.error("Error fetching systems:", error);
    throw error;
  }
};
export const getActiveSystems = async () => {
  try {
    const response = await base.get(`${newSystemUrl}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching systems:", error);
    throw error;
  }
};

/**
 * Get system by ID
 * @param systemId - The ID of the system to fetch
 * @returns Promise with system data
 */
export const getSystemById = async (systemId: string) => {
  try {
    const response = await base.get(`${newSystemUrl}/${systemId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching system by ID:", error);
    throw error;
  }
};

/**
 * Add new system
 * @param payload - System data to create
 * @returns Promise with created system data
 */
export const addSystem = async ({ payload }: { payload: any }) => {
  try {
    const response = await base.post(`${newSystemUrl}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error adding system:", error);
    throw error;
  }
};

/**
 * Update system
 * @param currentSystemId - The ID of the system to update
 * @param payload - Updated system data
 * @returns Promise with updated system data
 */
export const updateSystem = async ({
  currentSystemId,
  payload,
}: {
  currentSystemId: string;
  payload: any;
}) => {
  try {
    const response = await base.put(
      `${newSystemUrl}/${currentSystemId}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error updating system:", error);
    throw error;
  }
};

/**
 * Delete system
 * @param systemId - The ID of the system to delete
 * @returns Promise with deletion result
 */
export const deleteSystem = async (systemId: string) => {
  try {
    const response = await base.delete(`${newSystemUrl}/${systemId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting system:", error);
    throw error;
  }
};

/**
 * Reactivate system
 * @param systemId - The ID of the system to reactivate
 * @returns Promise with reactivation result
 */
export const reactivateSystem = async (systemId: string) => {
  try {
    const response = await base.put(`${newSystemUrl}/${systemId}/reactivate`);
    return response.data;
  } catch (error) {
    console.error("Error reactivating system:", error);
    throw error;
  }
};

/**
 * Get paginated systems list - NEW FUNCTION for paginated endpoint
 * @param page - Page number (default: 1)
 * @param size - Page size (default: 25)
 * @param searchTerm - Search term for filtering systems
 * @param isActive - Filter by active status ("true", "false", or "all")
 * @param signal - AbortSignal for request cancellation
 * @returns Promise with paginated systems data
 */
export const getPaginatedSystems = async (
  page: number = 1,
  size: number = 25,
  searchTerm?: string,
  signal?: AbortSignal,
  isActive: string = "true"
) => {
  try {
    let url = `${newSystemUrl}/all/pages?page=${page}&size=${size}`;

    // Add is_active parameter if not "all"
    if (isActive !== "all") {
      const isActiveBoolean = isActive === "true" ? "true" : "false";
      url += `&is_active=${isActiveBoolean}`;
    }

    // Add search parameter if searchTerm is provided and has minimum 3 characters
    if (searchTerm && searchTerm.trim().length >= 3) {
      url += `&value=${encodeURIComponent(searchTerm.trim())}`;
    }

    const response = await base.get(url, {
      signal, // Add abort signal for request cancellation
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching paginated systems:", error);
    throw error;
  }
};

// Get all systems - optionally filtered by specific system IDs
export const getAllSystemList = async (system_id?: number) => {
  try {
    let response;
    // Build query parameters
    const queryParams = new URLSearchParams();
    if (system_id) {
      queryParams.append("system_id", system_id.toString());
    }
    // Construct the URL
    const queryString = queryParams.toString();
    const url = queryString
      ? `${getAllSystemUrl}/all?${queryString}`
      : getAllSystemUrl;
    response = await base.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
